import { render, staticRenderFns } from "./addPrivilegeGroup.vue?vue&type=template&id=3ffc136a&scoped=true"
import script from "./addPrivilegeGroup.vue?vue&type=script&lang=js"
export * from "./addPrivilegeGroup.vue?vue&type=script&lang=js"
import style0 from "./addPrivilegeGroup.vue?vue&type=style&index=0&id=3ffc136a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ffc136a",
  null
  
)

export default component.exports